module.exports = __webpack_public_path__ + "img/attendance-report-header.b9df6855.png";